<template>
  <div
    class="skeleton"
    :style="{
      width,
      height,
      '--skeleton-base': baseColor,
      '--skeleton-shine': shineColor,
      '--skeleton-radius': borderRadius,
    }"
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    baseColor?: string;
    shineColor?: string;
    borderRadius?: string;
  }>(),
  {
    width: "100%",
    height: "24px",
    baseColor: "var(--color-border-default)",
    shineColor: "var(--color-coolGrey-p3)",
    borderRadius: "var(--border-radius-large)",
  },
);
</script>

<style lang="scss">
.skeleton {
  border-radius: var(--skeleton-radius, var(--border-radius-large));
  background: var(--skeleton-base);
  overflow: hidden;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent 0%, var(--skeleton-shine) 50%, transparent 100%);
    animation: shimmer 2.5s infinite;
    will-change: transform;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
